import CmsService from "../services/CmsService";

export const getPagesFromCms = async (page, language) => {
  const api = new CmsService();
  try {
    if (page) {
      const response = await api.getPageSingleType(
        language === "eng" ? `${page}?_locale=en` : `${page}?_locale=${language}-BE`
      );
      return response.hide;
    }
  } catch (error) {
    console.error(error);
  }
};

export const filterMenuBasedOnCms = async (cards, language) => {
  const result = await Promise.all(
    cards.map(async (card) => {
      const hide = await getPagesFromCms(card.cmsId, language);
      if (!hide) {
        return card;
      }
    })
  );
  return result.filter((element) => element !== undefined);
};

export const getPageListToShow = async (language) => {
  const pageListToShow = [{ page: "abroad" }, { page: "accident" }, { page: "access" }];
  return await Promise.all(
    pageListToShow.map(async (item) => {
      const hide = await getPagesFromCms(item.page, language);
      return { ...item, hide: hide };
    })
  );
};
